import { useContext } from "react";
import UtilsContext from "../context/UtilsProvider";

const useUtils = () => {
  return useContext(UtilsContext);
};

export default useUtils;
